/* Bestfind24 v5 – Banner-Slider */
(function () {
  var root = document.querySelector('[data-bf5-slider]'); if (!root) return;
  var slides = [].slice.call(root.querySelectorAll('.bf5-slide')), dots = [].slice.call(root.querySelectorAll('[data-dot]'));
  var i = 0, timer = null, reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function go(n) {
    i = (n + slides.length) % slides.length;
    slides.forEach(function (s, k) {
      var on = k === i; s.classList.toggle('is-on', on); s.setAttribute('aria-hidden', on ? 'false' : 'true');
      var a = s.querySelector('a'); if (a) a.tabIndex = on ? 0 : -1;
    });
    dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
  }
  function start() { if (reduce) return; stop(); timer = setInterval(function () { go(i + 1); }, 6500); root.classList.add('is-auto'); }
  function stop() { clearInterval(timer); timer = null; root.classList.remove('is-auto'); }
  root.querySelector('[data-prev]').addEventListener('click', function () { go(i - 1); start(); });
  root.querySelector('[data-next]').addEventListener('click', function () { go(i + 1); start(); });
  dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.dataset.dot); start(); }); });
  root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
  root.addEventListener('focusin', stop);
  var x0 = null;
  root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  root.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); start(); } x0 = null; });
  document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
  start();
})();